"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rmDebounce = void 0;
function rmDebounce(fn, t, immediate) {
    var timer;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var noTimer = !timer;
        clearTimeout(timer);
        timer = setTimeout(function () {
            timer = null;
            if (!immediate && typeof fn === "function")
                fn.apply(this, args);
        }, t);
        if (immediate && noTimer && typeof fn === "function")
            fn.apply(this, args);
    };
}
exports.rmDebounce = rmDebounce;
//# sourceMappingURL=debounce.js.map
//# sourceMappingURL=module.js.map